module.exports = __webpack_public_path__ + "img/redHill.dd64af81.svg";